import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { FeatureFlagService, FeatureType } from '../services/feature-flags';

@Injectable()
export class FeatureFlagGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let requiredFeature = route.data['requiredFeature'] as FeatureType;

    const isEnabled = this.featureFlagService.getFeatureEnabled(requiredFeature) ?? true;

    if (!isEnabled) {
      this.router.navigate(['/']);
    }

    return isEnabled;
  }
}
